import * as PIXI from "pixi.js";
import ServiceLocator from "../ServiceLocator";
import Utils from "../Utils";
import { Signal } from "signals";


export default class LobbyBigButton extends PIXI.Container
{
    private _type: lobby_big_button_type = null;

    private _anim: PIXI.AnimatedSprite = null;

    private _state: state_type = null;


    private _onTap: Signal = null;
    private _onSelectionAnimCompleted: Signal = null;


    public set type( value: lobby_big_button_type ) { this._type = value; }

    public get onTap(): Signal { return this._onTap; }
    public get onSelectionAnimCompleted(): Signal { return this._onSelectionAnimCompleted; }
    
    
    public constructor()
    {
        super();
    }

    public init(): void
    {
        this._onTap = new Signal();
        this._onSelectionAnimCompleted = new Signal();

        this.interactive = true;
        this.buttonMode = true;

        this.scale.set( 0.97 );

        this._state = state_type.IDLE;

        this._anim = new PIXI.AnimatedSprite( Utils.createTexArray( "button_" + ( this._type == lobby_big_button_type.CLASSIC ? "classic" : "friends" ) + "_mode_", 21 ) );
        this._anim.animationSpeed = 40;
        this._anim.loop = false;
        this._anim.autoUpdate = false;
        if ( this._type == lobby_big_button_type.PLAY_WITH_FRIENDS )
        {
            this._anim.anchor.set( 330/810, 490/1029 );
        }
        else
        {
            this._anim.anchor.set( 345/805, 492/1028 );
        }
        this.addChild( this._anim );
        this._anim.onFrameChange = ( currentFrame: number ) => {
            if ( this._state == state_type.POINTER_DOWN 
                && this._anim.currentFrame > 5 )
            {
                this._anim.gotoAndStop( 5 );
            }
        };
        this._anim.onComplete = () => { 
            this._state = state_type.IDLE;

            this._onSelectionAnimCompleted.dispatch(); 
        };
        //
        this._anim.gotoAndStop( 0 );

        this.on( "pointerdown", this.onPointer_Down, this );
        this.on( "pointerupoutside", this.onPointer_UpOutside, this );
        this.on( "pointertap", this.onPointer_Tap, this );
        this.on( "pointerover", this.onPointer_Over, this );
        this.on( "pointerout", this.onPointer_Out, this );
    }

        private onPointer_Down(): void
        {
            this._anim.gotoAndPlay( 0 );

            this._state = state_type.POINTER_DOWN;
        }

        private onPointer_UpOutside(): void
        {
            if ( this._state == state_type.POINTER_DOWN
                && this._anim.currentFrame < 6 )
            {
                this._anim.gotoAndStop( 0 );

                this._state = state_type.IDLE;
            }
        }

        private onPointer_Tap(): void
        {
            ServiceLocator.audio.playSfx( "ui_button_click" );
            
            if ( this._state == state_type.POINTER_DOWN 
                && !this._anim.playing )
            {
                this._anim.play();
            }

            this._state = state_type.TAP;

            this._onTap.dispatch();
        }

        private onPointer_Over(): void
        {
            if ( this._state == state_type.IDLE )
            {
                this.scale.set( 1 );
            }
        }

        private onPointer_Out(): void
        {
            if ( this._state == state_type.IDLE )
            {
                this.scale.set( 0.97 );
            }
        }

    public end(): void
    {
        this._onTap.dispose();
        this._onTap = null;

        this._onSelectionAnimCompleted.dispose();
        this._onSelectionAnimCompleted = null;
    }

    public update( dt: number ): void
    {
        this._anim.update( dt );
    }
    
}

export const enum lobby_big_button_type
{
    CLASSIC = 0,
    PLAY_WITH_FRIENDS
}

const enum state_type
{
    IDLE = 0,
    POINTER_DOWN,
    POINTER_UP_OUTSIDE,
    TAP
}